module.exports = __webpack_public_path__ + "static/img/Satya-Nadella-Microsoft.52eab60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/Satya-Nadella-Microsoft.jpg
// module id = RYZs
// module chunks = 0